import { __assign } from "tslib";
import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';
export function CenteredSpinner(props) {
    return (React.createElement(Flex, { flex: 1, justify: "center", align: "center" },
        React.createElement(Spinner, __assign({ size: "xl", thickness: "4px", color: "brand.500", label: "Loading..." }, props))));
}
